export default __webpack_public_path__ + "static/media/partner-4.3865e3be.jpg";